import React from 'react';
import {Outlet} from 'react-router-dom';
import {Navbar} from "../Navbar/Navbar";

const MainLayout = () => {
    return (
        <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
            <div className="z-50 shrink-0">
                <Navbar/>
            </div>
            
            <main className="flex-1 overflow-y-auto">
                <Outlet/>
            </main>
        </div>
    );
};

export default MainLayout;